export default function initMobilemenu(params) {
    const burger = document.querySelector(".header__menu-burger")
    if(!burger) return


    const menu = document.querySelector('.header__mobilemenu')
    burger.addEventListener("click", () => {
        if (body.classList.contains("mobilemenu-opened")) {
            document.removeEventListener("click", outsideEvtListener)
        } else {
            setTimeout(() => {
                document.addEventListener("click", outsideEvtListener)
            })
        }

        burger.classList.toggle("active")
        body.classList.toggle("mobilemenu-opened")
    })
    function outsideEvtListener(evt) {
        if (evt.target === menu || menu.contains(evt.target)) return
        burger.classList.toggle('active')
        body.classList.toggle('mobilemenu-opened')

        document.removeEventListener('click', outsideEvtListener);
    }

}
